import * as React from 'react'

import {
  FieldError,
  FieldLabel,
} from '~/client/src/shared/components/shadcn-ui/field'

interface IProps {
  htmlFor: string
  error?: React.ReactNode
  children: React.ReactNode
}

export const fieldErrorId = (htmlFor: string): string => `${htmlFor}-error`

export function FieldLabelRow({ htmlFor, error, children }: IProps) {
  return (
    <div className="tw:flex tw:items-baseline tw:justify-between tw:gap-2">
      <FieldLabel htmlFor={htmlFor} className="tw:gap-1">
        {children}
      </FieldLabel>
      {error && (
        <FieldError
          id={fieldErrorId(htmlFor)}
          className="tw:text-right tw:text-app-dense"
        >
          {error}
        </FieldError>
      )}
    </div>
  )
}
